export const ACCEPT_RATIO = .83;
export const DECLINE_RATIO = .17;
